/**
 * Dialog organism style mappings.
 *
 * @internal Used by Dialog, DialogHeader, DialogBody, DialogFooter.
 */

import type { IconWrapperSize } from '../../atoms/IconWrapper/IconWrapper.types';
import type { TypographyVariant } from '../../atoms/Typography/Typography.types';

// --- Dialog (shell) ---
export const maxWidthClasses = {
  sm: 'w-full sm:max-w-sm',
  md: 'w-full sm:max-w-md',
  lg: 'w-full sm:max-w-lg md:max-w-lg',
  xl: 'w-full sm:max-w-xl md:max-w-xl',
  '2xl': 'w-full sm:max-w-2xl md:max-w-2xl',
  full: 'w-full max-w-full',
} as const;

/** Icon size derived from title typography variant for visual harmony */
export const typographyToIconSize: Record<TypographyVariant, IconWrapperSize> = {
  h1: 'xl',
  h2: 'lg',
  h3: 'md',
  h4: 'md',
  h5: 'sm',
  h6: 'sm',
  'body-lg': 'md',
  'body-md': 'sm',
  'body-sm': 'xs',
  'body-xs': 'xs',
  caption: 'xs',
};

// --- DialogFooter ---
export const footerAlignStyles = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
} as const;
